<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      {{ $t('general.copyWrite') }}  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://mom.ir"
        target="_blank"
      >{{ $t('general.mom') }}</b-link>
      <span class="d-none d-sm-inline-block" />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
